import { render, staticRenderFns } from "./stepper1.vue?vue&type=template&id=487a87a8&scoped=true"
import script from "./stepper1.vue?vue&type=script&lang=js"
export * from "./stepper1.vue?vue&type=script&lang=js"
import style0 from "./stepper1.vue?vue&type=style&index=0&id=487a87a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a87a8",
  null
  
)

export default component.exports